import { combineReducers } from 'redux'
import chatState from './chats'

export default combineReducers({
    chatState
})